import { render, staticRenderFns } from "./SignupView.vue?vue&type=template&id=2c3a6e2a"
import script from "./SignupView.vue?vue&type=script&lang=js"
export * from "./SignupView.vue?vue&type=script&lang=js"
import style0 from "./SignupView.vue?vue&type=style&index=0&id=2c3a6e2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports